var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_5361",
    "data-name": "\\u7EC4 5361",
    transform: "translate(-27 -275)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_259",
    "data-name": "\\u692D\\u5706 259",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(27 275)",
    fill: "#1678ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_3896",
    "data-name": "\\u8DEF\\u5F84 3896",
    d: "M143.819,100.377l.012-.564c2.68-1.872,3.982-5.174,3.982-10.062,0-4.714-2.947-7.528-7.888-7.528h-.267c-4.935,0-7.888,2.813-7.888,7.528,0,4.865,1.314,8.167,4.017,10.051v.57c-4.5.6-9.01,2.395-9.01,5.133,0,3.831,4.377,5.772,13.015,5.772s13.015-1.942,13.015-5.772C152.806,102.772,148.306,100.982,143.819,100.377Z",
    transform: "translate(-89.791 200.25)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.c0031344740daaadbd00f449298e2cd6.svg";
export { ForwardRef as ReactComponent };